// extracted by mini-css-extract-plugin
export var colorSquare = "_uk-0";
export var danger = "_uk-5";
export var lightPink = "_uk-8";
export var neutralBlue = "_uk-7";
export var neutralYellow = "_uk-6";
export var normal = "_uk-1";
export var primary = "_uk-2";
export var primaryLight = "_uk-3";
export var solidBlack = "_uk-g";
export var solidGreen = "_uk-b";
export var solidLightBlue = "_uk-d";
export var solidNavy = "_uk-c";
export var solidOrange = "_uk-f";
export var solidPink = "_uk-e";
export var solidRed = "_uk-9";
export var solidYellow = "_uk-a";
export var success = "_uk-4";